const routes = [
  {
    path: '/day-test',
    name: 'day-test',
    component: () => import('@/views/game/game-play/Index.vue'),
    meta: {
      title: '互动答题',
      hideShare: true,
    },
  },
  {
    path: '/day-test/game',
    name: 'day-test-game',
    component: () => import('@/views/game/game-play/Game.vue'),
    meta: {
      title: '互动答题',
      hideShare: true,
    },
  },
  {
    path: '/day-test/result',
    name: 'day-test-result',
    component: () => import('@/views/game/game-play/Result.vue'),
    meta: {
      title: '互动答题-结果',
      hideShare: true,
    },
  },
  {
    path: '/day-test/error-list',
    name: 'day-test-error-list',
    component: () => import('@/views/game/game-play/ErrorList.vue'),
    meta: {
      title: '互动答题-错题分析',
      hideShare: true,
    },
  },
];
export default routes;
